import { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { apiJson } from "../../utils/api.js";
import { setAppDisplayTimezone } from "../../utils/displayTimezone.js";
import { getInitData } from "../../utils/initData.js";

export function IndexRedirectPage() {
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const [error, setError] = useState(null);

  const userId = useMemo(() => search.get("user_id"), [search]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const initData = getInitData();
      if (!initData) {
        setError("Откройте приложение из Telegram");
        return;
      }
      try {
        const me = await apiJson("/api/me");
        setAppDisplayTimezone(me?.iana_timezone);
        if (cancelled) return;
        if (userId) {
          navigate(`/chat/${encodeURIComponent(userId)}?return_to=/chat`, { replace: true });
          return;
        }
        if (me) navigate("/deals", { replace: true });
      } catch {
        if (!cancelled) setError("Нет доступа");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate, userId]);

  if (error) {
    return (
      <div className="pill" style={{ margin: "2rem", textAlign: "center" }}>
        {error}
      </div>
    );
  }
  // Без стартовой страницы: просто быстрый редирект.
  return null;
}

